import React from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { green, red } from "@material-ui/core/colors";
import moment from "moment";
class MerchantStats extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.merchantStats;
  }

  render() {
    const { merchantStats } = this.props.merchantStats;

    return (
      <div>
        <style type="text/css">
          {`
    .btn-flat {
      display: inline;
      background-color: #cdcecf;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #7dc3ae85;
      color: #2f0246;
      border-radius: 8px;
      border: 1px solid teal;  
    }
    `}
        </style>
        <Navbar className="bg-primary justify-content-between">
          <Navbar.Brand>
            Merchants <Badge variant="light">{merchantStats.length}</Badge>
          </Navbar.Brand>
          <Link to="/create-merchant">
            <Button variant="primary">Create Merchant</Button>
          </Link>
        </Navbar>
        <Table className="bg-flat" responsive>
          <thead>
            <tr>
              <th>
                <Button variant="link" onClick={() => this.props.sort("id")}>
                  Id
                </Button>
              </th>
              <th>
                <Button variant="link">Merchant</Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("monthcount")}
                >
                  {moment(Date.now()).format("MMM")} / YoY
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("awaitcount")}
                >
                  Awaiting
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("prevmonthcount")}
                >
                  {moment(Date.Now).subtract(1, "months").format("MMM")} vs{" "}
                  {moment(Date.Now).subtract(2, "months").format("MMM")}
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("yearcount")}
                >
                  {moment(Date.Now).format("YYYY")}
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("prevyearcount")}
                >
                  {moment(Date.Now).subtract(1, "years").format("YYYY")} vs{" "}
                  {moment(Date.Now).subtract(2, "years").format("YYYY")}
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("allcount")}
                >
                  All Time
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("monthrevsum")}
                >
                  {moment(Date.Now).format("MMM")} Revenue
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("yearrevsum")}
                >
                  {moment(Date.Now).format("YYYY")} Revenue
                </Button>
              </th>
              <th>
                <Button
                  variant="link"
                  onClick={() => this.props.sort("allrevsum")}
                >
                  All Time Revenue
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {merchantStats.map((merch) => (
              <tr key={merch.id}>
                <td>
                  <Link to={`/merchants/${merch.id}`}>{merch.id}</Link>
                </td>
                <td>{merch.name}</td>
                <td>
                  {merch.monthcount || 0} {merch.monthprevyearcount && "/"}{" "}
                  {merch.monthprevyearcount || ""}
                </td>
                <td>{merch.awaitcount || 0}</td>
                <td>
                  {" "}
                  {merch.prevmonthcount || 0}
                  {merch.prevmonthcount && (
                    <span>
                      {merch.prevprevmonthcount ? (
                        merch.prevmonthcount - merch.prevprevmonthcount > 0 ? (
                          <span className="text-success">
                            <ArrowDropUpIcon style={{ color: green[500] }} />
                            {merch.prevmonthcount - merch.prevprevmonthcount}
                          </span>
                        ) : (
                          <span className="text-danger">
                            <ArrowDropDownIcon style={{ color: red[500] }} />
                            {merch.prevprevmonthcount - merch.prevmonthcount}
                          </span>
                        )
                      ) : (
                        <span className="text-success">
                          <ArrowDropUpIcon style={{ color: green[500] }} />
                          {merch.prevmonthcount}
                        </span>
                      )}
                    </span>
                  )}
                </td>
                <td>{merch.yearcount || 0}</td>
                <td>
                  {merch.prevyearcount || 0}
                  {merch.prevyearcount && (
                    <span>
                      {merch.prevprevyearcount ? (
                        merch.prevyearcount - merch.prevprevyearcount > 0 ? (
                          <span className="text-success">
                            <ArrowDropUpIcon style={{ color: green[500] }} />
                            {merch.prevyearcount - merch.prevprevyearcount}
                          </span>
                        ) : (
                          <span className="text-danger">
                            <ArrowDropDownIcon style={{ color: red[500] }} />
                            {merch.prevprevyearcount - merch.prevyearcount}
                          </span>
                        )
                      ) : (
                        <span className="text-success">
                          <ArrowDropUpIcon style={{ color: green[500] }} />
                          {merch.prevyearcount}
                        </span>
                      )}
                    </span>
                  )}
                </td>
                <td>{merch.allcount || 0}</td>
                <td>
                  {merch.monthrevsum
                    ? new Intl.NumberFormat("ca-EN", {
                        style: "currency",
                        currency: "CAD",
                      }).format(merch.monthrevsum / 100)
                    : 0}
                </td>
                <td>
                  {merch.yearrevsum
                    ? new Intl.NumberFormat("ca-EN", {
                        style: "currency",
                        currency: "CAD",
                      }).format(merch.yearrevsum / 100)
                    : 0}
                </td>
                <td>
                  {merch.allrevsum
                    ? new Intl.NumberFormat("ca-EN", {
                        style: "currency",
                        currency: "CAD",
                      }).format(merch.allrevsum / 100)
                    : 0}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(MerchantStats);
